import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FdFormComponentsModule} from '../shared/fd-form-components/fd-form-components.module';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MccPhysicalPersonComponent } from './mcc-physical-person.component';
import { AddMccComponent } from './components/add-mcc/add-mcc.component';
import { ListMccComponent } from './components/list-mcc/list-mcc.component';
import { HistoryMccComponent } from './components/history-mcc/history-mcc.component';
import { PipesModule } from '../shared/pipes/pipes.module';


@NgModule({
  declarations: [
    ListMccComponent, 
    AddMccComponent, 
    HistoryMccComponent,
    MccPhysicalPersonComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatCheckboxModule,
    FdFormComponentsModule,
    FormsModule,
    MatTabsModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatCardModule,
    MatExpansionModule,
    MatToolbarModule,
    FontAwesomeModule,
    MatPaginatorModule,
    MaterialFileInputModule, 
    PipesModule
  ]
})
export class MccPhysicalPersonModule {}
